import React from 'react'

export default function QuestionCategoryBadge({categoryName}) {
  if (!categoryName) return null

  return <span className="question-category-badge">{categoryName}</span>
}

